import { Navigate, useParams } from "react-router-dom";
import { PATH_AUTH } from "config";

/**
 * Redirect component for legacy /verify_account/:status routes
 * Redirects to the new /email/verification/:status route for backward compatibility
 */
export const VerifyAccountRedirect = () => {
  const { status } = useParams<{ status: string }>();
  return <Navigate to={`${PATH_AUTH.emailVerification}/${status || ""}`} replace />;
};
